module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-all-uk.d0ea7ae0.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-all-uk.png
// module id = 2620
// module chunks = 11